function getPrioridadeLinha(nomeRecurso, valorAtual, valorReferencia, regimeTributario) {

    const prioridadePorc = (parseFloat(valorAtual) / parseFloat(valorReferencia) * 100 || 0).toFixed(2);

    if (nomeRecurso === 'MONITOR_DISCO_BANCO') {
        if (prioridadePorc < 80) {
            return { color: '#FB3548', fontWeight: '700' };
        } else {
            return { color: '#FFB736', fontWeight: '700' };
        }
    }

    if (valorAtual === 'MONITOR_MEMORIA') {
        if (valorAtual > 4294967296) {
            return { color: '#FFB736', fontWeight: '700' };
        } else if (valorAtual > 8589934592) {
            return { color: '#FB3548', fontWeight: '700' };
        } else {
            return {};
        }
    }

    if (nomeRecurso === 'MONITOR_DISCO_WINDOWS') {
        if (valorAtual < 5368709120) {
            return { color: '#FB3548', fontWeight: '700' };
        } else if (valorAtual < 10737418240) {
            return { color: '#FFB736', fontWeight: '700' };
        } else {
            return {};

        }
    }

    if (nomeRecurso === 'MONITOR_BLOCOX_ESTOQUE' ) {
        if ( regimeTributario ==='SIMPLES NACIONAL')
        return { color: '#FB3548', fontWeight: '700' }
    }

}
export default getPrioridadeLinha;